import numeral from "numeral";
import moment from "moment";

export const filters = {
  formatNumber(value: number) {
    return numeral(value).format("0,0.00");
  },
  formatNumber5Decimals(value: number) {
    return numeral(value).format("0,0.00000");
  },
  formatDatetime(value) {
    if (value) {
      return moment(String(value)).format("DD/MM/YYYY hh:mmA");
    } else {
      return value;
    }
  },
  formatDateAndTime(value) {
    if (value) {
      return moment(String(value)).format("DD/MM/YYYY hh:mm:ssA");
    } else {
      return value;
    }
  },
  formatDate(value) {
    if (value) {
      return moment(String(value)).format("DD/MM/YYYY");
    } else {
      return value;
    }
  },
  formatDateTemis(value) {
    if (value) {
      const d = String(value).split(" ");
      const formaDate = moment(d[0], "DD/MM/YYYY", true);
      if (formaDate.isValid()) {
        return d[0];
      } else {
        return moment(String(d[0])).format("DD/MM/YYYY");
      }
    } else {
      return value;
    }
  },
  formatDatetimeTemis(value) {
    if (value) {
      const d = String(value).split(" ");
      let date = "";
      const formaDate = moment(d[0], "DD/MM/YYYY", true);
      if (formaDate.isValid()) {
        date = d[0];
      } else {
        date = moment(String(d[0])).format("DD/MM/YYYY");
      }

      return date + " " + d[1];
    } else {
      return value;
    }
  },
  formatDateAndtimeTemis(value) {
    if (value) {
      const d = String(value).split(" ");
      let date = "";
      const formaDate = moment(d[0], "DD/MM/YYYY", true);
      if (formaDate.isValid()) {
        date = d[0];
      } else {
        date = moment(String(d[0])).format("DD/MM/YYYY");
      }

      return date + " " + d[1];
    } else {
      return value;
    }
  },
};
